<template>
  <div v-if="errors">
    <div v-for="error in errors" :key="error" class="input__error">
      {{ error }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'FieldError',
  props: {
    errors: {
      type: Array,
      default: () => null,
    },
  },
}
</script>
